import useConfiguration from './useConfiguration';

/**
 * Hook to determine if Microsoft SSO is currently active on the account.
 * SSO is considered active when a configuration exists with status 'active'.
 *
 * @returns {object} Object containing:
 *   - isSsoActive: true if SSO is active, false otherwise
 *   - isLoading: true while configuration is being fetched
 */
const useIsSsoActive = () => {
  const { config, isLoading } = useConfiguration();

  const isSsoActive = !!config && config.status === 'active';

  return {
    isSsoActive,
    isLoading,
  };
};

export default useIsSsoActive;
